import { Type } from '@sinclair/typebox';
export const PATHFINDER_WS_PATH = '/v1/ws';
export var PathfinderWsMethod;
(function (PathfinderWsMethod) {
    PathfinderWsMethod["Ping"] = "ping";
    PathfinderWsMethod["Subscribe"] = "subscribe";
    PathfinderWsMethod["Unsubscribe"] = "unsubscribe";
})(PathfinderWsMethod || (PathfinderWsMethod = {}));
export var PathfinderWsPushMethod;
(function (PathfinderWsPushMethod) {
    PathfinderWsPushMethod["Quote"] = "quote";
})(PathfinderWsPushMethod || (PathfinderWsPushMethod = {}));
export var PathfinderWsErrorCode;
(function (PathfinderWsErrorCode) {
    PathfinderWsErrorCode[PathfinderWsErrorCode["ParseError"] = -32700] = "ParseError";
    PathfinderWsErrorCode[PathfinderWsErrorCode["InvalidRequest"] = -32600] = "InvalidRequest";
    PathfinderWsErrorCode[PathfinderWsErrorCode["MethodNotFound"] = -32601] = "MethodNotFound";
    PathfinderWsErrorCode[PathfinderWsErrorCode["InvalidParameters"] = -32602] = "InvalidParameters";
    PathfinderWsErrorCode[PathfinderWsErrorCode["QuoteNotFound"] = -32001] = "QuoteNotFound";
})(PathfinderWsErrorCode || (PathfinderWsErrorCode = {}));
export const PathfinderTipSenderTypeSchema = Type.Union([
    Type.Literal('custom'),
    Type.Literal('helius'),
    Type.Literal('jito'),
    Type.Literal('0slot'),
]);
export const PathfinderWsRoomKeySchema = Type.Object({
    token_in: Type.String(),
    token_out: Type.String(),
    amount: Type.Number(),
    allow_split: Type.Boolean(),
}, { title: 'PathfinderWsRoomKey' });
export const PathfinderWsSubscribeParametersSchema = Type.Object({
    token_in: Type.String(),
    token_out: Type.String(),
    amount: Type.Number(),
    allow_split: Type.Boolean(),
    taker: Type.Optional(Type.String()),
    referral_code: Type.Optional(Type.String()),
    slippage: Type.Optional(Type.Number()),
    priority: Type.Optional(Type.Number()),
    tip: Type.Optional(Type.Number()),
    compute_unit: Type.Optional(Type.Number()),
    sender_type: Type.Optional(PathfinderTipSenderTypeSchema),
    use_alt: Type.Optional(Type.Boolean()),
}, { title: 'PathfinderWsSubscribeParameters' });
export const PathfinderWsSubscribeResultSchema = Type.Object({ subscription_id: Type.Number() }, { title: 'PathfinderWsSubscribeResult' });
export const PathfinderWsUnsubscribeParametersSchema = Type.Object({ subscription_id: Type.Number() }, { title: 'PathfinderWsUnsubscribeParameters' });
export const PathfinderWsRpcIdSchema = Type.Union([
    Type.Number(),
    Type.String(),
    Type.Null(),
]);
export const PathfinderWsRpcErrorSchema = Type.Object({
    code: Type.Number(),
    message: Type.String(),
}, { title: 'PathfinderWsRpcError' });
export const buildPathfinderWsRequestSchema = (parametersSchema) => Type.Object({
    jsonrpc: Type.Literal('2.0'),
    id: Type.Optional(Type.Union([Type.Number(), Type.String()])),
    method: Type.String(),
    params: Type.Optional(parametersSchema),
});
export const buildPathfinderWsSuccessSchema = (resultSchema) => Type.Object({
    jsonrpc: Type.Literal('2.0'),
    id: PathfinderWsRpcIdSchema,
    result: resultSchema,
});
export const PathfinderWsRpcErrorResponseSchema = Type.Object({
    jsonrpc: Type.Literal('2.0'),
    id: PathfinderWsRpcIdSchema,
    error: PathfinderWsRpcErrorSchema,
}, { title: 'PathfinderWsRpcErrorResponse' });
export const PathfinderWsQuotePayloadSchema = Type.Unsafe(Type.Object({}, { additionalProperties: true }));
export const PathfinderWsQuoteSuccessParametersSchema = Type.Object({
    room: PathfinderWsRoomKeySchema,
    result: PathfinderWsQuotePayloadSchema,
}, { title: 'PathfinderWsQuoteSuccessParams' });
export const PathfinderWsQuoteErrorParametersSchema = Type.Object({
    room: PathfinderWsRoomKeySchema,
    error: Type.Object({ message: Type.String() }),
}, { title: 'PathfinderWsQuoteErrorParams' });
export const PathfinderWsQuoteNotificationSchema = Type.Object({
    jsonrpc: Type.Literal('2.0'),
    method: Type.Literal(PathfinderWsPushMethod.Quote),
    params: Type.Union([
        PathfinderWsQuoteSuccessParametersSchema,
        PathfinderWsQuoteErrorParametersSchema,
    ]),
}, { title: 'PathfinderWsQuoteNotification' });
export const isPathfinderWsQuoteSuccess = (notification) => 'result' in notification.params;
export const isPathfinderWsQuoteError = (notification) => 'error' in notification.params;
export const serializePathfinderWsRoomKey = (room) => `${room.token_in}|${room.token_out}|${room.amount}|${room.allow_split ? 1 : 0}`;
//# sourceMappingURL=index.js.map